"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = exports.Body = exports.Title = exports.Header = exports.Container = exports.CollapsibleItemHeader = exports.CollapsibleItemBody = exports.CollapsibleItem = exports.CollapsibleSection = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
const CollapsibleSections_1 = require("./CollapsibleSections");
Object.defineProperty(exports, "CollapsibleSection", { enumerable: true, get: function () { return CollapsibleSections_1.CollapsibleSection; } });
Object.defineProperty(exports, "CollapsibleItem", { enumerable: true, get: function () { return CollapsibleSections_1.CollapsibleItem; } });
Object.defineProperty(exports, "CollapsibleItemBody", { enumerable: true, get: function () { return CollapsibleSections_1.CollapsibleItemBody; } });
Object.defineProperty(exports, "CollapsibleItemHeader", { enumerable: true, get: function () { return CollapsibleSections_1.CollapsibleItemHeader; } });
exports.Container = (0, styled_components_1.default)(react_bootstrap_1.Offcanvas) `
  box-shadow: 0 1.625rem 5rem rgba(0, 0, 0, 0.2),
    0 0 0.0625rem rgba(0, 0, 0, 0.2);
  border-left: 1px solid ${config_1.colors.huron};
`;
exports.Header = (0, styled_components_1.default)(react_bootstrap_1.Offcanvas.Header) `
  align-items: center;
  top: 0;
  width: 100%;
  padding: 1rem;
  border-bottom: 1px;
  box-sizing: border-box;
  display: flex;
  height: 3.5rem;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  width: 100%;
`;
exports.Title = (0, styled_components_1.default)(react_bootstrap_1.Offcanvas.Title) `
  font-weight: 600;
  font-size: ${config_1.fontSizes.base};
  font-family: ${config_1.fontFamilies.primary};
  margin-bottom: 0;
`;
exports.Body = (0, styled_components_1.default)(react_bootstrap_1.Offcanvas.Body) `
  padding: 0;
`;
const StyledCloseButton = styled_components_1.default.button `
  background: none;
  border: none;
  i {
    font-weight: 600;
    font-size: 1.2rem;
  }
`;
const CloseButton = ({ onClick, icon = 'arrow-right' }) => (react_1.default.createElement(StyledCloseButton, { onClick: onClick },
    react_1.default.createElement("i", { className: `fe fe-${icon}` })));
exports.CloseButton = CloseButton;
